import React, { Component } from 'react';
import { connect } from 'react-redux';
import {  Modal } from '../../components';
import { getFilteredShoutouts, modalNext, modalBack, showCodeCommitStats, clearModal } from '../../actions/TVModeAction';
import './TVModeModal.scss';
import { getShoutoutsBefore } from '../../actions/ShoutoutsActions';
import { TVModeModalOptions, TVModeModalTimeFrame, TVModeModalRecipient, TVModeModalDisplayOptions, TVModeModalFooter } from './TVModeModalSections';

class TVModeModal extends Component {
  state = {
    showModal: false,
    showStats: false
  };

  showModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  async goToTVMode(disabled) {
    if (disabled) return;
    else {
      localStorage.setItem('timeFrame', this.props.timeFrame);
      localStorage.setItem('selectedUsers', JSON.stringify(this.props.selectedUsers || []));
      localStorage.setItem('showStats', this.state.showStats || false);
      await this.props.showCodeCommitStats(this.state.showStats);
      await this.props.getFilteredShoutouts(this.props.selectedUsers, this.props.timeFrame);
      this.props.openTVMode();
    }
  }

  chooseSection(section, timeFrame, recipient) {
    this.setState({ timeFrame, recipient, section }, () => {
      if (!this.state.recipient) this.setState({ selectedUsers: [] });
    });
  }

  chooseShowStats(show) {
    this.setState({ showStats: show });
  }

  // setTimeFrame(frame) {
  //   this.setState({ timeFrameRange: frame });
  // }

  // setSelectedUsers(users) {
  //   this.setState({ selectedUsers: users });
  // }

  renderSection() {
    const { timeFrame, recipient, showStats } = this.state;
    const { modalStep } = this.props;

    switch (modalStep) {
      case 0:
        return (
          <TVModeModalOptions
            showStats={showStats}
            openTVMode={this.goToTVMode.bind(this)}
            chooseShowStats={this.chooseShowStats.bind(this)}
          />
        );
      case 1:
        return (
          <TVModeModalTimeFrame
            timeFrame={timeFrame}
            recipient={recipient}
            // timeFrameRange={timeFrameRange}
            // setTimeFrame={this.setTimeFrame.bind(this)}
            chooseSection={this.chooseSection.bind(this)}
            openTVMode={this.goToTVMode.bind(this)}
          />
        );
      case 2:
        return (
          <TVModeModalRecipient
            timeFrame={timeFrame}
            recipient={recipient}
            users={this.props.users}
            // selectedUsers={selectedUsers}
            // setSelectedUsers={this.setSelectedUsers.bind(this)}
            chooseSection={this.chooseSection.bind(this)}
            openTVMode={this.goToTVMode.bind(this)}
          />
        );
      case 3:
        return (
          <TVModeModalDisplayOptions
            timeFrame={timeFrame}
            recipient={recipient}
            users={this.props.users}
            chooseSection={this.chooseSection.bind(this)}
            openTVMode={this.goToTVMode.bind(this)}
          />
        );
      default:
        return null;
    }
  }

  renderSubtitle(){
    const { modalStep } = this.props;
    switch (modalStep) {
      case 3:
        return "Where would you like them displayed?";
      default:
        return "What do you want to display?";
    }
  }

  render() {
    const { showModal } = this.state;
    return (
      <Modal
        showModal={showModal}
        closeModal={()=> {
          this.closeModal();
          this.props.clearModal();
        }
        }
      >
        <div className="modal-holder" style={{ backgroundColor: 'white' }}>
          <div ref={(ref) => this.header = ref} className="tv-modal-header">
            <div className="modalTitle">LAUNCH TV MODE</div>
            <div className="modalSubtitle">{this.renderSubtitle()}</div>
          </div>
          {this.renderSection()}
          <TVModeModalFooter
            openTVMode={this.goToTVMode.bind(this)}
          />
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = ({ usersStore, shoutoutsStore, tvModeStore }) => {
  const { users } = usersStore;
  const { tvShoutouts } = shoutoutsStore;

  const { timeFrame, timeFrameSelected, recipientSelected, modalStep } = tvModeStore;
  return { timeFrame, users, selectedUsers: tvModeStore.users, shoutouts: tvShoutouts, timeFrameSelected, recipientSelected, modalStep, showCodeCommitStats };
};

export default connect(mapStateToProps, { getFilteredShoutouts, getShoutoutsBefore, modalNext, modalBack, clearModal }, null, { withRef: true })(TVModeModal);





// WEBPACK FOOTER //
// ./src/screens/dashboard/TVModeModal.js